module.exports = __webpack_public_path__ + "img/banner-11z.0947a7b0.png";